export default __webpack_public_path__ + "static/media/F0006.952cf498.png";